export default __webpack_public_path__ + "static/media/classroomImg3.965e23b2.svg";